import { render, staticRenderFns } from "./SecurityModal.vue?vue&type=template&id=5ec04247&scoped=true"
import script from "./SecurityModal.vue?vue&type=script&lang=js"
export * from "./SecurityModal.vue?vue&type=script&lang=js"
import style0 from "./SecurityModal.vue?vue&type=style&index=0&id=5ec04247&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec04247",
  null
  
)

export default component.exports